import React, { Component } from 'react';
import { Route, Prompt } from 'react-router-dom';
import { last, sortBy } from 'lodash';
import moment from 'moment';
import classnames from 'classnames';

import TabStructure from '../../ui/tab';

import SubNav from '../sub-nav';
import Utilities from '../utilities/index';

import General from '../../../containers/event/after-action/general';
import UploadFiles from '../../../containers/event/after-action/upload-files';
import Questions from '../../../containers/event/after-action/questions';
import Ratings from '../../../containers/event/after-action/ratings';
import PromoItems from '../../../containers/event/after-action/promo-items';
import Notes from '../../../containers/event/after-action/notes';
import ErrorPage from '../../errorPage';

class AfterAction extends Component {
    constructor(props) {
        super(props);
        this.formContent = [
            {
                path: 'general',
                title: 'General',
                content: <General />
            },
            {
                path: 'upload-files',
                title: 'Upload Files',
                content: <UploadFiles />
            },
            {
                path: 'questions',
                title: 'Questions',
                content: <Questions />
            },
            {
                path: 'ratings',
                title: 'Ratings',
                content: <Ratings />
            },
            {
                path: 'promo-items',
                title: 'Promo Items',
                content: <PromoItems />
            },
            {
                path: 'notes',
                title: 'Notes',
                content: <Notes />
            }
        ];
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.successMessage && !this.props.successMessage) {
            this.scrollToTop();
        } else if (nextProps.errorMessage && !this.props.errorMessage) {
            this.scrollToTop();
            const that = this;
            setTimeout(function() {
                that.props.clearAllErrors();
            }, 10000);
        }
    }

    render() {
        const activeIndex = this.formContent.findIndex(
            item => item.path === this.props.match.params.tab
        );

        let requestMessage = null;
        if (this.props.tasks && this.props.tasks.length > 0) {
            const mostRecentTask = last(sortBy(this.props.tasks, 'id'));
            if (mostRecentTask.action === 'Info') {
                requestMessage = (
                    <div className="event__rejection">
                        <p>
                            More information was requested for this after action
                            by{' '}
                            <strong>{mostRecentTask.updatedByUsername}</strong>{' '}
                            on{' '}
                            <strong>
                                {moment(mostRecentTask.updatedAt).format(
                                    'MMMM Do, YYYY'
                                )}
                            </strong>
                        </p>
                        <div>
                            <p>{this.props.requestMessage}</p>
                        </div>
                    </div>
                );
            }
        }

        let successMessage = null;
        if (this.props.successMessage) {
            successMessage = (
                <div className="event__success">
                    <span onClick={this.props.clearMessage}>
                        <span className="visually-hidden">
                            Remove the success message
                        </span>
                        <svg className="icon icon-close">
                            <use xlinkHref="#icon-close" />
                        </svg>
                    </span>
                    <p>{this.props.successMessage}</p>
                </div>
            );
        }

        let errorMessage = null;
        if (this.props.errorMessage) {
            errorMessage = (
                <div className="event__error">
                    <p>{this.props.errorMessage}</p>
                </div>
            );
        }

        let overlayClass = classnames('form-action-overlay', {
            'is-active': this.props.eventActionLoading
        });

        return activeIndex === -1 ? (
            <Route component={ErrorPage} />
        ) : (
            <div>
                <Prompt
                    when={this.props.location.pathname.startsWith(
                        '/event/after-action'
                    )}
                    message={location => {
                        return !location.pathname.startsWith(
                            '/event/after-action'
                        )
                            ? 'Do you wish to leave the page? Any unsaved changes will be lost.'
                            : true;
                    }}
                />
                {requestMessage}
                {successMessage}
                {errorMessage}
                <SubNav
                    eventId={this.props.eventId}
                    contract={this.props.contract}
                    startDate={this.props.startDate}
                    prAccessible={this.props.prAccessible}
                    status={this.props.status}
                />

                <div className={overlayClass}>
                    <div className="form-action-overlay__content">
                        <svg className="icon icon-logo">
                            <use xlinkHref="#icon-logo" />
                        </svg>

                        <div className="form-action-overlay__text">
                            {this.props.eventActionText}
                        </div>

                        <svg
                            className="loading__spinner"
                            width="60"
                            height="20"
                            viewBox="0 0 60 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="7" cy="15" r="4" />
                            <circle cx="30" cy="15" r="4" />
                            <circle cx="53" cy="15" r="4" />
                        </svg>
                    </div>
                </div>

                <div className="event__content">
                    <div className="event__header">
                        {this.props.eventName ? (
                            <div className="event__event-name">
                                {this.props.eventName}
                            </div>
                        ) : null}
                        <Utilities
                            eventId={this.props.eventId}
                            jwtToken={this.props.jwtToken}
                            print
                        />
                    </div>

                    <TabStructure
                        items={this.formContent}
                        tab={this.props.match.params.tab}
                    />
                </div>
            </div>
        );
    }
}

export default AfterAction;



// WEBPACK FOOTER //
// ./src/components/event/after-action/index.js